import { Link, useLocation } from "react-router-dom";
import { clearAuthSession } from "../services/auth";

function AdminLayout({ title, children, rightContent }) {
  const location = useLocation();

  function getLinkStyle(path) {
    const isActive = location.pathname === path;

    return {
      display: "block",
      padding: "12px 14px",
      borderRadius: "10px",
      textDecoration: "none",
      fontWeight: isActive ? "bold" : "normal",
      background: isActive ? "#1f2937" : "transparent",
      color: isActive ? "white" : "#9ca3af",
      transition: "0.2s",
    };
  }

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "#f3f4f6",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          width: "240px",
          background: "#0f172a",
          color: "white",
          padding: "28px 20px",
          boxSizing: "border-box",
        }}
      >
        <h2
          style={{
            marginTop: 0,
            marginBottom: "30px",
            fontSize: "22px",
          }}
        >
          Admin Panel
        </h2>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <Link to="/admin/orders" style={getLinkStyle("/admin/orders")}>
            Orders
          </Link>

          <Link to="/admin/products" style={getLinkStyle("/admin/products")}>
            Products
          </Link>

          <Link
            to="/admin/add-product"
            style={getLinkStyle("/admin/add-product")}
          >
            Add Product
          </Link>
        </div>
      </div>

      <div style={{ flex: 1 }}>
        <div
          style={{
            background: "white",
            padding: "20px 30px",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: "24px",
              color: "#111827",
            }}
          >
            {title}
          </h1>

          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <span style={{ color: "#6b7280", fontSize: "14px" }}>
              Admin
            </span>

            <button
              onClick={() => {
                clearAuthSession();
                window.location.href = "/admin/login";
              }}
              style={{
                background: "#dc2626",
                color: "white",
                border: "none",
                padding: "8px 14px",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "bold"
              }}
            >
              Logout
            </button>
          </div>
        </div>

        <div style={{ padding: "30px" }}>{children}</div>
      </div>
    </div>
  );
}

export default AdminLayout;
